import { render } from "./Photos.vue?vue&type=template&id=b1f2f978&scoped=true&bindings={\"isThumbnail\":\"props\",\"photos\":\"setup\",\"getPhotoImage\":\"options\"}"
import script from "./Photos.vue?vue&type=script&lang=js"
export * from "./Photos.vue?vue&type=script&lang=js"

import "./Photos.vue?vue&type=style&index=0&id=b1f2f978&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b1f2f978"

export default script